import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { cnBem } from "../../../../shared/lib";
import styles from "./styles.pcss";
var cnSkeleton = cnBem('skeleton', styles);
export var Skeleton = function Skeleton(_ref) {
  var _ref$side = _ref.side,
    side = _ref$side === void 0 ? 'main' : _ref$side;
  return /*#__PURE__*/React.createElement("div", {
    className: cnSkeleton({
      side: side
    })
  }, side === 'opposite' && /*#__PURE__*/React.createElement("div", {
    className: cnSkeleton('avatar')
  }), /*#__PURE__*/React.createElement("div", {
    className: cnSkeleton('message', {
      side: side
    }),
    style: _defineProperty({}, '--message-width', "".concat(200 + Math.random() * 50, "px"))
  }));
};